import { ERouteName } from '~/app/router/routeName.enum';
import type { TAppFooterConfig } from '../models/appFooter.model';
import type { EMMIconName } from '@mm-frontend/mm-web-ui-kit';

const currentYear = new Date().getFullYear();
const inn = '1648054022';

function getFooterConfig(currentDomain: string): TAppFooterConfig {
  return {
    groups: [
      {
        title: 'О нас',
        links: [
          {
            title: 'О компании',
            to: { name: ERouteName.ABOUT },
          },
          {
            title: 'Вакансии',
            to: { name: ERouteName.ABOUT_CAREERS },
          },
          {
            title: 'Контакты и реквизиты',
            to: { name: ERouteName.ABOUT_CONTACT },
          },
          {
            title: 'Пункты выдачи заказов',
            to: { name: ERouteName.ABOUT_DELIVERY_POINTS },
          },
        ],
      },
      {
        title: 'Покупателям',
        links: [
          {
            title: 'Как сделать заказ?',
            to: { name: ERouteName.FAQ, hash: '#kak-zakazat' },
          },
          {
            title: 'Как оплатить?',
            to: { name: ERouteName.FAQ, hash: '#kak-oplatit-zakaz' },
          },
          {
            title: 'Доставка',
            to: { name: ERouteName.FAQ, hash: '#kak-bystro-dostavyat-moj-zakaz' },
          },
          {
            title: 'Возврат',
            to: { name: ERouteName.FAQ, hash: '#kak-vernut-slozhnuyu-tekhniku' },
          },
          {
            title: 'Вопрос-ответ',
            to: { name: ERouteName.FAQ },
          },
          {
            title: 'Связаться с нами',
            to: '#contacts',
          },
          {
            title: 'Защита от мошенников',
            to: `${currentDomain}/static/docs/informirovanie_o_moshennichestve_mm.pdf`,
            target: '_blank',
          },
        ],
      },
      {
        title: 'Партнёрам',
        links: [
          {
            title: 'Войти в личный кабинет',
            to: 'https://seller.mm.ru/seller/signin',
          },
          {
            title: 'Стать партнёром',
            to: 'https://seller.mm.ru/',
          },
          {
            title: 'Магнит Пост',
            to: 'https://post.magnit.ru/',
          },
          {
            title: 'Логистическим партнёрам',
            to: 'https://legal.mm.ru/logistics',
          },
          {
            title: 'Сервис для корпоративных покупателей',
            to: 'https://b2b.mm.ru/',
          },
          {
            title: 'Логистика',
            to: 'https://logisticmagnitmarket.ru/',
          },
          {
            title: 'Фотостудия',
            to: 'https://photostudio.mm.ru/?utm_source=mm&utm_medium=footer',
          },
        ],
      },
    ],
    social: [
      {
        title: 'ВКонтакте',
        to: 'https://vk.com/magnitmrkt',
        icon: 'social-vk' as EMMIconName,
        description: '@magnitmrkt',
      },
    ],
    support: {
      phone: '8 800 700 96 16',
      description: 'Бесплатный звонок по России',
      email: 'info_mm@magnit.ru',
    },
    copyright: `«${currentYear}© ООО «Магнит Маркет» ИНН ${inn}. Все права защищены»`,
    bottomLinks: [
      {
        title: 'Соглашение о конфиденциальности',
        to: 'https://legal.mm.ru/#data_policy',
      },
      {
        title: 'Пользовательское соглашение',
        to: 'https://legal.mm.ru/#polzovatelskoe_soglashenie',
      },
      {
        title: 'Правила рекомендательных технологий',
        to: 'https://legal.mm.ru/#rules_technology',
      },
    ],
  };
}

export default getFooterConfig;
